<template>
    <div class="modal-properties-container">
        <div class="modal-header">
        </div>

        <div class="column-modal tree">
            <div class="description">
                <icon class="icons medium-svg" name="locations" />
                <h4>Objekter</h4>
            </div>
            <div class="column">
                <tree :data="treeNodes" :filter="filter" :options="options" ref="tree" class="tree-container" @node:selected="openFeature" @node:checked="nodeChecked" @node:unchecked="nodeChecked">
                    <div slot-scope="{ node }" class="node-container">
                        <div  class="node-text">
                            <icon v-if="node.states.isParent === true" class="layers smaller-svg" name="layers" />
                            <icon v-else-if="node.data.geometry === 'POLYGON'" class="layers smaller-svg" name="pathpoint" />
                            <icon v-else-if="node.data.geometry === 'POINT'" class="layers smaller-svg" name="round" />
                            <icon v-else-if="node.data.geometry === 'LINESTRING'" class="layers smaller-svg" name="line" />
                            <span v-if="!node.states.isParent && node.data.layerName"> {{ node.data.layerName }}, </span>
                            <span v-else-if="!node.states.isParent && !node.data.layerName && node.data.layerId"> {{ node.data.layerId }}, </span>
                            <span style="display: inline-block;"> {{node.text}} </span>
                        </div>
                    </div>
                </tree>
            </div>
        </div>
        <div class="column-modal properties">
            <div class="description">
                <icon class="icons medium-svg" name="properties" />
                <h4>Attributter</h4>
                <div class="filtering">
                    <icon class="small-svg" name="filter" />
                    <input type="search" placeholder="Filtrer..." v-model="filter">
                </div>
            </div>
            <div class="column">

                <div v-if="this.editing && !properties && differentLayers"><b>Der er blevet valgt objekter fra flere forskellige lag, vælg kun objekter fra det samme lag.</b></div>
                <div v-else-if="this.editing && !properties">Vælg nogle objekter i venstre kolonne hvor der ønskes at ændre attribut værdier.</div>

                <div class="grid" v-if="!editing">
                    <template v-for="(property, index) in properties">
                        <div :key="'name'+ index">
                            <span>{{ property.name }}</span>
                        </div>
                        <div v-if="property.type === 'dateTime' || property.name.includes('date') || (property.value && (property.value.toString().endsWith('Z') || property.value.toString().includes('GMT')))" :key="'value' + index">
                            <b><span>{{ property.value | formatDateShort }}</span></b>
                        </div>
                        <div v-else-if="typeof property.value === 'boolean'" :key="'value' + index">
                            <b><span>{{ property.value | formatBoolean }}</span></b>
                        </div>
                        <div v-else-if="!property.link" :key="'value'+ index">
                            <b><span>{{ property.value }}</span></b>
                        </div>
                        <div v-else :key="'link' + index">
                            <a :href="property.link">{{ property.value }}</a>
                        </div>
                    </template>
                </div>

                <div class="grid" v-else>
                    <template v-for="(property, index) in properties">
                        <template v-if="!property.isGeometry">
                            <div :key="'name'+ index">
                                <span>{{property.name}}</span>
                            </div>

                            <div v-if="property.type === 'string' && property.values === null" :key="'inputString' + index">
                                <input class="editing-property-input" type="text" v-model="property.selected" @change="updatePropertyState(property)" :disabled="isEditable(property)">
                            </div>

                            <div v-else-if="(property.type === 'int' || property.type === 'float') && property.values === null" :key="'inputInt' + index">
                                <input class="editing-property-input" type="number" v-model.number="property.selected" :disabled="isEditable(property)" @change="updatePropertyState(property)">
                            </div>

                            <div v-else-if="property.type === 'dateTime'" :key="'date' + index">
                                <div class="calendar-input">
                                    <base-date-picker id="properties-date" v-model="property.selected">Dato</base-date-picker>
                                    <icon class="calendar small-svg" name="calendar" />
                                </div>
                            </div>

                            <select v-else-if="property.type === 'boolean'" class="editing-property-input" :key="'selectable' + index" v-model="property.selected" @change="updatePropertyState(property)">
                                <option value="">(tom værdi)</option>
                                <option value="true">Ja</option>
                                <option value="false">Nej</option>
                            </select>

                            <div v-else-if="property.type === null && property.values === null" :key="'InputDisabled' + index">
                                <input class="editing-property-input" :value='property.selected' :disabled="isEditable(property)" @change="updatePropertyState(property)">
                            </div>

                            <select v-else class="editing-property-input" :key="'selectable' + index" v-model="property.selected" @change="updatePropertyState(property)">
                                <option value="">(tom værdi)</option>
                                <option v-for="(value, index) in property.values" :value="value" :key="index">{{ value }}</option>
                                <option value="-" hidden>-</option>
                            </select>
                        </template>
                    </template>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" :disabled="saveAbleChanges" v-if="editing" @click="savePropertyChanges()">Gem ændringer</button>
                <button type="button" class="button-blue" v-if="!editing && checkLayerEditable" @click="changeEditMode()">Rediger</button>
                <button type="button" class="button-red" v-if="editing" @click="changeEditMode()">Afbryd</button>
                <button type="button" class="button-naked" v-if="!editing" @click="closeModal()">Luk</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from './../../../store/api'
import LiquorTree from 'liquor-tree'
import BaseDatePicker from '@/components/base/BaseDatePicker.vue'

export default {
    name: 'properties-modal',
    components: {
        'tree': LiquorTree,
        BaseDatePicker
    },
    props: [
        'data'
    ],
    data () {
        return {
            treeNodes: [],
            filter: null,
            editing: false,
            options: {
                checkbox: !!this.editing,
                filter: {
                    emptyText: 'Der blev ikke fundet noget',
                    matcher (query, node) {
                        if (node.data.featureProperties) {
                            return node.data.featureProperties.some(p => p.name.toLowerCase().includes(query.toLowerCase()) || (typeof p.value === 'string' ? p.value.toLowerCase().includes(query.toLowerCase()) : p.value === parseInt(query)))
                        }
                    }
                },
                propertyName: {
                    text: 'name',
                    children: 'features'
                }
            },
            properties: null,
            unFilteredProperties: null,
            differentLayers: false,
            layerId: null,
            layerName: null
        }
    },
    created () {
        this.treeNodes = this.data.layers.map((element, i) => {
            return {
                text: element.name,
                state: {
                    visible: true,
                    isParent: true,
                    expanded: true,
                    checkbox: true
                },
                children: element.features.map((feature, y) => {
                    return {
                        text: feature.name,
                        data: {
                            layerId: feature.layerId,
                            layerName: feature.layerName,
                            featureProperties: feature.properties,
                            objectIdPropertyName: feature.objectIdPropertyName,
                            dataSourceId: feature.dataSourceId,
                            geometry: this.checkGeometryType(feature.geometry),
                            gml: feature.geometry
                        },
                        state: {
                            selected: !!(y === 0 && i === 0),
                            visible: true
                        }
                    }
                })
            }
        })
        this.properties = this.treeNodes[0].children[0].data.featureProperties
        this.addLinkToProperties()
    },
    watch: {
        filter: function () {
            if (this.filter) {
                if (!this.unFilteredProperties) {
                    this.unFilteredProperties = this.properties
                }
                this.properties = this.unFilteredProperties.filter(p => p.name.toLowerCase().includes(this.filter.toLowerCase()) || (typeof p.value === 'string' ? p.value.toLowerCase().includes(this.filter.toLowerCase()) : p.value === parseInt(this.filter)))
            } else {
                this.properties = this.unFilteredProperties
                this.unFilteredProperties = null
            }
            this.addLinkToProperties()
        }
    },
    computed: {
        ...mapGetters({
            applicationSettings: 'getApplicationSettings',
            selectedSupplyType: 'selectedSupplyType'
        }),
        getLayerProperties: function () {
            // Find the possible values and types for the properties of the selected layer
            const mapService = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.find((service) => {
                return (service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo') && service.layers.find(layer => layer.id === this.layerId || layer.name === this.layerName)
            })

            if (mapService && mapService.layers) {
                const layer = mapService.layers.find(layer => layer.id === this.layerId || layer.name === this.layerName)

                if (layer) {
                    return layer.editObjectProperties
                }
            }

            return null
        },
        saveAbleChanges: function () {
            const selectedNodes = this.getSelectedNodes()
            this.checkMultiplelayers(selectedNodes)
            if (selectedNodes[0].length > 0 && !this.differentLayers) {
                return false
            } else {
                return true
            }
        },
        checkLayerEditable: function () {
            return this.data.layers.every(l => l.features.every(f => f.updateable === true))
        }
    },
    mounted () {
        if (this.data.editOnLoad) {
            this.$watch(() => {
                return this.$refs.tree.model
            }, (val) => {
                this.changeEditMode()
            })
        }
    },
    methods: {
        addLinkToProperties () {
            if (this.properties && !this.properties.some(p => p.name === 'Url')) {
                if (this.properties.some(p => p.name === 'DriveType')) {
                    let type = 'henvendelse'
                    if (this.properties.find(p => p.name === 'DriveType').value === 'task') {
                        type = 'opgave'
                    }

                    this.properties.push({
                        name: 'Url',
                        value: 'Link til ' + type,
                        link: '/' + type + '/' + this.properties.find(p => p.name === 'Id').value
                    })
                }
            }
        },
        changeEditMode () {
            this.unFilteredProperties = this.properties
            this.properties = null
            this.$refs.tree.opts.checkbox = !this.$refs.tree.opts.checkbox
            this.editing = !this.editing
            if (this.data.editOnLoad) {
                // Select all objects
                this.$refs.tree.model.forEach(model => {
                    model.states.checked = true
                    model.children.forEach(node => { node.states.checked = true })
                })

                this.nodeChecked()
            } else {
                const selectedNodes = this.getSelectedNodes()
                if (selectedNodes[0].length > 0) {
                    this.properties = selectedNodes[0][0].data.featureProperties
                }
                this.$refs.tree.model.forEach(model => {
                    model.states.checked = false
                    model.children.forEach((node) => {
                        node.states.checked = false
                    })
                })
            }
        },
        closeModal () {
            this.$emit('close')
        },
        checkGeometryType (geometry) {
            if (geometry) {
                if (typeof geometry === 'object') {
                    // GML32
                    if (geometry.outerHTML.toLowerCase().includes('point')) {
                        return 'POINT'
                    } else if (geometry.outerHTML.toLowerCase().includes('polygon')) {
                        return 'POLYGON'
                    } else if (geometry.outerHTML.toLowerCase().includes('linestring')) {
                        return 'LINESTRING'
                    } else {
                        return 'POLYGON'
                    }
                } else {
                    // WKT
                    if (geometry.includes('POINT')) {
                        return 'POINT'
                    } else if (geometry.includes('POLYGON')) {
                        return 'POLYGON'
                    } else if (geometry.includes('LINESTRING')) {
                        return 'LINESTRING'
                    } else {
                        return 'POLYGON'
                    }
                }
            }
        },
        checkMultiplelayers (selectedNodes) {
            if (selectedNodes[0].length > 0) {
                // Check if multiple layers are selected
                // layerId also changes the layer got from 'getLayerProperties'
                this.layerId = selectedNodes[0][0].data.layerId
                this.layerName = selectedNodes[0][0].data.layerName
                const validateMultipleLayers = selectedNodes.some(nodes => nodes.every(node => node.data.layerId === this.layerId))
                if (validateMultipleLayers) {
                    this.differentLayers = false
                } else {
                    this.differentLayers = true
                }
            }
        },
        checkEditableLayers (selectedNodes) {
            const mapServices = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.filter((service) => {
                return service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo'
            })

            if (mapServices && mapServices.length > 0) {
                const updateable = selectedNodes[0].every(node => {
                    return mapServices.some(service => service.layers.find(layer => (layer.id === node.data.layerId || layer.name === node.data.layerName) && layer.updateable))
                })

                if (!updateable) {
                    this.differentLayers = false
                }
            }
        },
        openFeature (node) {
            if (!this.editing) {
                if (this.filter) {
                    this.unFilteredProperties = node.data.featureProperties
                    this.properties = node.data.featureProperties.filter(p => p.name.toLowerCase().includes(this.filter.toLowerCase()) || p.value.toLowerCase().includes(this.filter.toLowerCase()))
                } else {
                    this.properties = node.data.featureProperties
                }
                this.addLinkToProperties()
            }
        },
        nodeChecked () {
            // Find and check if any checked nodes
            const selectedNodes = this.getSelectedNodes()

            this.checkMultiplelayers(selectedNodes)
            const nodeLengths = selectedNodes.some(nodes => {
                return nodes.length > 0
            })

            this.checkEditableLayers(selectedNodes)

            if (nodeLengths && !this.differentLayers) {
                if (!this.differentLayers) {
                    // Find the selected values
                    this.properties = this.getLayerProperties.map(prop => {
                        const values = []
                        selectedNodes[0].forEach(node => {
                            // Find the values on the features
                            const feature = node.data.featureProperties.find(data => data.name === prop.name)
                            if (feature) {
                                if (feature.value !== null || feature.value !== undefined || feature.value !== '') {
                                    values.push(feature.value)
                                }
                            }
                        })

                        // Add a updated state variable
                        prop.updated = false

                        if (this.data.populateValues) {
                            prop.selected = '-'
                        } else {
                            // Get the selected value to be displayed
                            if (values.length === 0) {
                                // No values selected on any property therefore empty field
                                prop.selected = ''
                            } else if (!values.every(v => v === values[0]) && selectedNodes[0].length > 1) {
                                // The values are different
                                prop.selected = '-'
                            } else {
                                // The values are not different or there is only one node selected, therefore take the value from the first node
                                prop.selected = values[0]
                            }
                        }
                        return prop
                    })
                } else {
                    this.properties = null
                }
            } else {
                this.properties = null
            }
        },
        savePropertyChanges () {
            // Get the checked nodes
            const selectedNodes = this.getSelectedNodes()
            // Get dataSourceId
            const dataSourceId = selectedNodes[0][0].data.dataSourceId
            // Find the properties that are updated
            const updatedProperties = this.properties.filter(prop => prop.updated === true)
            // Check what keyPropertyName
            const keyPropertyname = selectedNodes[0].map(node => node.data.objectIdPropertyName)
            const isAllEqual = keys => keys.every(v => v === keys[0])

            if (isAllEqual) {
                // Extract globalIDs
                const globalIDs = selectedNodes[0].map(node => node.data.featureProperties.find(prop => prop.name === keyPropertyname[0]).value)

                // Make Property array with objects only having name and value // Don't update object if the value is '-'
                const propertyList = updatedProperties.map(prop => {
                    const updatedProperty = {
                        name: prop.name,
                        type: prop.type,
                        value: prop.selected
                    }

                    if (prop.type === 'boolean') {
                        if (prop.selected === 'true') {
                            updatedProperty.value = true
                        } else if (prop.selected === 'false') {
                            updatedProperty.value = false
                        } else {
                            updatedProperty.value = null
                        }
                    } else if (prop.selected === '') {
                        updatedProperty.value = null
                    }

                    return updatedProperty
                }).filter(prop => prop.value !== '-')

                // API call with the nodes that are updated
                axios.post('Gis/UpdateGisObjects', {
                    datasourceId: dataSourceId,
                    propertyList: propertyList,
                    filterKeyList: globalIDs
                }).then(() => {
                    // Edit the properties values so the changes can be viewed when switched out of edit mode

                    // For each variable changed...
                    propertyList.forEach(updatedProp => {
                        this.$refs.tree.model[0].children.forEach(node => node.data.featureProperties.forEach(prop => {
                            if (prop.name === updatedProp.name) {
                                // Change the tree's value
                                prop.value = updatedProp.value
                            }
                        }))
                    })

                    // Update info on map

                    // Go out of edit mode
                    this.changeEditMode()
                }).catch((error) => {
                    console.error('Update object attributes', error)
                    if (error.response) {
                        console.error('Update object attributes', error.response.status)
                    }
                })
            }
        },
        isEditable (prop) {
            const mapService = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.find((service) => {
                return (service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo') && service.layers.find(layer => layer.id === this.layerId || layer.name === this.layerName)
            })

            if (mapService && mapService.layers) {
                const layer = mapService.layers.find(layer => layer.id === this.layerId || layer.name === this.layerName)

                if (layer && (prop.name === 'OBJECTID' || prop.isGeometry || prop.name === layer.objectIdPropertyName)) {
                    return true
                }
            }

            return false
        },
        getSelectedNodes () {
            return this.$refs.tree.model.map(model => model.children.filter(node => node.states.checked === true))
        },
        updatePropertyState (prop) {
            prop.updated = true
        }
    },
    filters: {
        formatBoolean (string) {
            if (string) {
                return 'Ja'
            } else {
                return 'Nej'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/map/properties-modal.vue